import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output } from '@angular/core';
import * as i2 from 'primeng/selectbutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { IconComponent } from '@arematics/core/icon';
import * as i1 from '@arematics/keycloak-angular';
import * as i3 from 'primeng/api';

class UserVotingComponent {
    ref;
    auth;
    _upvotes = 0;
    _vote;
    options;
    selectedItem;
    disabled = true;
    set upvotes(upvotes) {
        this._upvotes = upvotes;
        this.options[0].upvotes = upvotes;
        this.ref.markForCheck();
    }
    get upvotes() {
        return this._upvotes;
    }
    set vote(vote) {
        this._vote = vote;
        this.selectedItem = vote ? (vote.upvote ? 'thumbs-up' : 'thumbs-down') : undefined;
        this.ref.markForCheck();
    }
    get vote() {
        return this._vote;
    }
    voteChange = new EventEmitter();
    constructor(ref, auth) {
        this.ref = ref;
        this.auth = auth;
        this.options = [
            { icon: 'thumbs-up', value: 'thumbs-up' },
            { icon: 'thumbs-down', value: 'thumbs-down' }
        ];
        this.disabled = !this.auth.isLoggedIn();
    }
    updateItem(event) {
        if (event === 'thumbs-up') {
            if (!this._vote) {
                this._vote = { upvote: true };
            }
            this._vote.upvote = true;
        }
        else if (event === 'thumbs-down') {
            if (!this._vote) {
                this._vote = { upvote: false };
            }
            this._vote.upvote = false;
        }
        else {
            this._vote = undefined;
        }
        this.voteChange.emit(this._vote);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserVotingComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i1.KeycloakService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: UserVotingComponent, isStandalone: true, selector: "a-user-voting", inputs: { upvotes: "upvotes", vote: "vote" }, outputs: { voteChange: "voteChange" }, ngImport: i0, template: `
		<p-selectButton
			[allowEmpty]="true"
			[disabled]="disabled"
			[options]="options"
			[(ngModel)]="selectedItem"
			styleClass="userVoteSelect"
			(ngModelChange)="updateItem($event)">
			<ng-template let-item pTemplate>
				<div class="flex align-items-center" style="gap: .4rem">
					<a-icon [icon]="item.icon" [solid]="selectedItem === item.value"></a-icon>
					<p class="m-0" *ngIf="item.upvotes">{{ item.upvotes }}</p>
				</div>
			</ng-template>
		</p-selectButton>
	`, isInline: true, styles: ["::ng-deep .userVoteSelect{background-color:var(--color-background)}::ng-deep .userVoteSelect .p-disabled{opacity:1}::ng-deep .userVoteSelect .p-button{border:none;background-color:#dedede;border-radius:20px}::ng-deep .userVoteSelect .p-button:first-of-type{border-top-right-radius:0;border-bottom-right-radius:0}::ng-deep .userVoteSelect .p-button:last-of-type{border-top-left-radius:0;border-bottom-left-radius:0}::ng-deep .userVoteSelect .p-button:not(:last-child){border-right:1px solid black}::ng-deep .userVoteSelect .p-button:hover{background-color:#d9d9d9}\n"], dependencies: [{ kind: "component", type: IconComponent, selector: "a-icon[icon]", inputs: ["icon", "size", "solid", "class"] }, { kind: "ngmodule", type: SelectButtonModule }, { kind: "component", type: i2.SelectButton, selector: "p-selectButton", inputs: ["options", "optionLabel", "optionValue", "optionDisabled", "tabindex", "multiple", "allowEmpty", "style", "styleClass", "ariaLabelledBy", "disabled", "dataKey"], outputs: ["onOptionClick", "onChange"] }, { kind: "directive", type: i3.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserVotingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a-user-voting', standalone: true, imports: [IconComponent, SelectButtonModule, FormsModule, NgIf], template: `
		<p-selectButton
			[allowEmpty]="true"
			[disabled]="disabled"
			[options]="options"
			[(ngModel)]="selectedItem"
			styleClass="userVoteSelect"
			(ngModelChange)="updateItem($event)">
			<ng-template let-item pTemplate>
				<div class="flex align-items-center" style="gap: .4rem">
					<a-icon [icon]="item.icon" [solid]="selectedItem === item.value"></a-icon>
					<p class="m-0" *ngIf="item.upvotes">{{ item.upvotes }}</p>
				</div>
			</ng-template>
		</p-selectButton>
	`, styles: ["::ng-deep .userVoteSelect{background-color:var(--color-background)}::ng-deep .userVoteSelect .p-disabled{opacity:1}::ng-deep .userVoteSelect .p-button{border:none;background-color:#dedede;border-radius:20px}::ng-deep .userVoteSelect .p-button:first-of-type{border-top-right-radius:0;border-bottom-right-radius:0}::ng-deep .userVoteSelect .p-button:last-of-type{border-top-left-radius:0;border-bottom-left-radius:0}::ng-deep .userVoteSelect .p-button:not(:last-child){border-right:1px solid black}::ng-deep .userVoteSelect .p-button:hover{background-color:#d9d9d9}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i1.KeycloakService }]; }, propDecorators: { upvotes: [{
                type: Input
            }], vote: [{
                type: Input
            }], voteChange: [{
                type: Output
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { UserVotingComponent };
